import React, { FC } from 'react';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';
// internal
import { getStyles as getDfltStyles } from './styles.css';
import block from './block.json';

export type SubsectionCenteredTextProps = {
	slug: string;
	author?: string;
	getStyles?: (styles: any) => string;
} & ThemeProps &
	ChildrenProps;

/**
 * COMPONENT
 */
export const SubsectionCenteredText: FC<SubsectionCenteredTextProps> &
	BlockConfigs = ({
	slug,
	author,
	children,
	theme = {},
	getStyles = getDfltStyles,
}) => {
	const { variant, blockTheme } = useThemeBlock(slug, theme);

	const trimmedSlug = slug.split('/');
	const modifierSlug = trimmedSlug[trimmedSlug.length - 1];

	const rootClass = cx(
		'supt-subsection',
		`supt-subsection--${modifierSlug}`,
		getStyles(blockTheme)
	);

	return (
		<div className={rootClass} data-block={slug} data-variant={variant}>
			<div className="supt-subsection__content">
				{children}
				{author ? (
					<p
						className="supt-subsection__author"
						dangerouslySetInnerHTML={{ __html: author }}
					/>
				) : null}
			</div>
		</div>
	);
};

SubsectionCenteredText.slug = block.slug;
SubsectionCenteredText.title = block.title;
